import { useLazyQuery } from '@apollo/client';
import { Button, message } from 'antd';
import { FC, useEffect, useMemo, useState } from 'react';
import { FileInfo, CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1Document } from '../../../../../../generated';
import { ReviewDocumentDocumentInfo, getDocumentInfo } from '../../../../../shared/review-documents/review-documents-helpers';
import { ReviewDocumentsModal } from '../../../../../shared/review-documents/review-documents-modal';

const DOCUMENT_CONFIG = {
  'cover-letter.pdf': { title: 'Cover Letter' },
  'verification-status-report.pdf': { title: 'Verification Status Report' }
} as ReviewDocumentDocumentInfo;

function useDocumentReview(caseId: string) {
  const [isOpen, setIsOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [fetchFiles, { data }] = useLazyQuery(CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1Document);

  useEffect(() => {
    if (isFetching) {
      fetchFiles({
        variables: { id: caseId },
        fetchPolicy: 'network-only'
      }).then((res) => {
        setIsFetching(false);
        if (res.error) {
          message.error('Failed to fetch files: ' + res.error.message);
          return;
        }
        if (res.data?.sendReportCaseV1?.files && res.data?.sendReportCaseV1?.files.length > 0) {
          setIsOpen(true);
        } else {
          message.info('No documents found to compare');
        }
      });
    }
  }, [isFetching, caseId]);

  const documentInfos = useMemo(() => {
    const files = data?.sendReportCaseV1?.files as FileInfo[];
    return files?.length ? getDocumentInfo(files, DOCUMENT_CONFIG) : {};
  }, [data]);

  return {
    isOpen,
    isFetching,
    documentInfos,
    startComparison: () => setIsFetching(true),
    closeModal: () => {
      setIsOpen(false);
    }
  };
}

interface ReviewDocumentsButtonContainerProps {
  caseId: string;
}
export const ReviewDocumentsButtonContainer: FC<ReviewDocumentsButtonContainerProps> = (props) => {
  const { isOpen, isFetching, documentInfos, startComparison, closeModal } = useDocumentReview(props.caseId);

  return (
    <>
      <Button loading={isFetching} onClick={startComparison}>
        Review Documents
      </Button>
      <ReviewDocumentsModal isOpen={isOpen} onClose={closeModal} documentInfos={documentInfos} />
    </>
  );
};
